export const translations = {
	zh: {
		title: "Baby Tyche",
		subtitle: "命运金库中奖查询",
		searchPlaceholder: "输入 Token ID、名称或代码查询中奖信息...",
		searchButton: "搜索",
		searching: "搜索中...",
		gameMechanics: "游戏机制",
		fateVault: "命运金库",
		searchInfo: "输入您的 Token ID、名称或代码查看是否中奖",
		luckMessage: "Baby Tyche 为您带来好运气 🍀",
		copyright: "© 2024 Baby Tyche. All rights reserved.",
		searchAlert: "搜索 Token ID:",
		announcement: "交易监控页面新上线！",
		checkWinning: "查中奖",
		checkData: "查数据",
		priceChanges: "涨跌幅",
		newListings: "新上线",
		upcomingLottery: "快开奖",
		marketCapRank: "市值榜",
		priceRank: "价格榜",
		switchToMarketCap: "切换到市值榜",
		switchToPrice: "切换到价格榜",
		liquidityRank: "流动池榜",
		switchToLiquidity: "切换到流动池榜",
		lpShare: "LP占比",
		noMarketCapTokens: "暂无市值榜数据",
		autoRefresh: "每3秒自动刷新",
		trades: "交易",
		marketCap: "市值",
		marketCapPrefix: "市值:",
		holdingsPrefix: "持仓:",
		chartOpen: "开盘",
		chartHigh: "最高",
		chartLow: "最低",
		chartClose: "收盘",
		chartVolume: "成交量",
		noResults: "暂无抽奖记录",
		ceremony: "第{round}轮抽奖",
		milestones: ["50%阶段", "60%阶段", "70%阶段", "80%阶段（毕业典礼）"],
		totalPool: "总奖池",
		distributed: "已发放",
		rollover: "流转至下轮",
		firstPrize: "一等奖",
		secondPrize: "二等奖",
		thirdPrize: "三等奖",
		winners: "获奖者",
		amount: "奖金",
		backToSearch: "返回搜索",
		pending: "等待开奖",
		completed: "已开奖",
		allCompleted: "全部抽奖已完成",
		partialCompleted: "已完成 {completed} / 4 轮抽奖",
		waitingForNext: "等待下一轮抽奖",
		userSearchPlaceholder: "输入用户 Principal 查询中奖记录...",
		userSearch: "查询中奖",
		userSearching: "查询中...",
		createdAt: "创建时间",
		status: "状态",
		description: "描述",
		links: "链接",
		website: "官网",
		twitter: "推特",
		tributeRatio: "贡品比例",
		tribute: "贡品",
		fateVaultContribution: "命运金库贡献",
		lotteryProgress: "开奖进度",
		milestone50: "50%",
		milestone60: "60%",
		milestone70: "70%",
		milestone80: "80%",
		prize1st: "一等奖",
		prize2nd: "二等奖",
		prize3rd: "三等奖",
		telegram: "电报",
		graduated: "已毕业",
		primary: "内盘阶段",
		upcomingRound: "第 {round} 轮快开奖",
		dataFrom: "数据来源",
		realtime: "实时",
		cache: "缓存",
		apiCallFailed: "API调用失败:",
		failedToGetTokenInfo: "获取token信息失败:",
		tokenInfo: "Token信息:",
		isFromCache: "是否来自缓存:",
		userWinResults: "用户中奖记录",
		noWinRecords: "该用户未中奖",
		winRecord: "中奖记录",
		tokenNotFound: "未找到代-币或加载失败。",
		creator: "创建者",
		buyShort: "买",
		sellShort: "卖",
		totalShort: "总",
		round: "第{round}轮",
		rank: "奖项",
		clearSearch: "清除搜索",
		totalWinnings: "总中奖金额",
		nav: {
			home: "首页",
			monitor: "监控",
			address: "地址",
			trade: "交易",
			airdrop: "空投",
			invite: "邀请",
			tools: "工具",
			activities: "活动",
			plaza: "广场",
			data: "数据",
			scan: "监控",
			toolsMenu: {
				oneClickAirdrop: "一键空投",
				internalTransfer: "内部转账浏览器",
				batchAirdrop: "批量空投",
				singleTransfer: "单个转账",
				frontrunner: "抢跑机器人",
				runeAddress: "Odin-Fomowell地址关联",
				web3BuildersAlliance: "Web3建设者联盟",
			},
			activitiesMenu: {
				babyOdinAirdrop: "BabyOdin空投",
				babyOdinInvite: "BabyOdin邀请",
			},
		},
		trade: {
			buy: "买入",
			sell: "卖出",
			auto: "自动",
			autoTrading: "自动交易",
			comingSoon: "功能开发中...",
			buySuccess: "买入成功",
			sellSuccess: "卖出成功",
			txFailed: "交易失败",
		},
		wallet: {
			connect: "连接钱包",
			connecting: "连接中...",
			connected: "已连接",
			disconnect: "断开连接",
			connectSuccess: "钱包连接成功!",
			connectError: "连接失败",
			notInstalled: "钱包未安装",
			clickToInstall: "点击安装",
			selectWallet: "选择钱包",
			myProfile: "个人资料",
			sendBTC: "发送 BTC",
			btcAddress: "BTC 地址",
			identityId: "身份 ID",
			copyAddress: "复制地址",
			copyId: "复制 ID",
			copied: "已复制",
			mainnetConnected: "主网已连接",
		},
		sendBtc: {
			title: "发送 BTC 给用户",
			subtitle: "通过输入对方的 Tyche ID 即时发送 BTC。",
			availableBalance: "可用余额：",
			recipientLabel: "收件人 Tyche ID",
			recipientPlaceholder: "输入收件人的 Tyche ID",
			formatHint:
				"格式：ff6ae-c2252-skzbs-25ekh-qrjpj-wumpy-orxeg-ijzjs-hx6gj-3ot35-axa",
			amountLabel: "金额 (BTC)",
			amountPlaceholder: "0.00000000",
			maxButton: "最大",
			minimumAmount: "最小金额 0.0001 BTC",
			fee: "手续费：10 sats",
			cancel: "取消",
			back: "返回",
			reviewSend: "确认并发送",
			send: "发送",
			sending: "发送中...",
			confirmTitle: "确认交易",
			to: "收件人：",
			amount: "金额：",
			usdValue: "美元价值：",
			feeLabel: "手续费：",
			total: "总计：",
		},
		auth: {
			signIn: "登录",
			signOut: "登出",
			signInWith: "使用 {provider} 登录",
			selectProvider: "选择登录方式",
			telegram: "Telegram",
			okxWallet: "OKX 钱包",
			cancel: "取消",
			signInDescription: "选择您偏好的登录方式来访问您的账户",
			dashboard: "个人中心",
			myBtcAddresses: "我的 BTC 地址",
			loading: "加载中...",
			or: "或者",
		},
		loading: "加载中...",
		userInfo: "用户信息",
		user: "用户",
		joinedDate: "注册时间",
		authMethods: "认证方式",
		link: "关联",
		linkedAt: "关联于",
		btcAddresses: "BTC地址",
		addressIsBot: "每个地址就是一个bot",
		total: "个",
		generate: "生成",
		addressCreatedAt: "创建于",
		noBtcAddresses: "还没有BTC地址",
		generateFirstAddress: "生成第一个地址",
		botStatus: "Bot状态",
		botStatusDesc: "当前运行的各种策略的BTC地址bot状态",
		noActiveBots: "暂无运行中的bot",
		botStatusHint: "Bot状态将在此处显示",
		accountLogs: "账号日志",
		accountLogsDesc: "您的最近账户活动记录",
		noActivityLogs: "暂无活动日志",
		default: "默认值",
		trading: {
			slippage: "滑点",
			balance: "余额",
			pay: "支付",
			receive: "收到",
			priceImpact: "价格影响",
			swap: "交易",
			swapping: "交易中...",
			swapSuccess: "交易成功",
			swapFailed: "交易失败",
			insufficientBalance: "余额不足",
			selectBot: "选择Bot",
			noBots: "没有可用的Bot",
			loadingBots: "加载Bot中...",
			refresh: "刷新",
			assets: "资产",
			txHistory: "交易历史",
			noTxHistory: "暂无交易历史",
			failedToLoadBots: "加载Bot失败",
			failedToLoadAssets: "加载资产失败",
			failedToLoadTxHistory: "加载交易历史失败",
			failedToGetQuote: "获取报价失败",
			trade: "交易",
			limitOrder: "挂单交易",
			buy: "买入",
			sell: "卖出",
			tokensReceived: "获得代币",
			btcReceived: "获得BTC",
			enterValidAmount: "请输入有效金额",
			processing: "处理中...",
			pleaseLogin: "请先登录",
		},
		liquidity: {
			liquidityPool: "流动池",
			add: "添加",
			remove: "移除",
			addLiquidity: "添加流动性",
			removeLiquidity: "移除流动性",
			yourLiquidity: "您的流动性",
			poolShare: "池子份额",
			requiredToken: "需要代币",
			depositRatio: "存入比例",
			btcReceived: "BTC 获得",
			tokenReceived: "代币获得",
			addSuccess: "添加流动性成功",
			removeSuccess: "移除流动性成功",
			addFailed: "添加流动性失败",
			removeFailed: "移除流动性失败",
			operationFailed: "操作失败",
			totalDeposit: "Total Deposit",
			noLiquidity: "您没有流动性",
		},
		bot: {
			create: "创建策略机器人",
			createButton: "创建机器人",
			creating: "创建中...",
			name: "机器人名称",
			namePlaceholder: "给你的机器人起个名字",
			tradingAddress: "交易地址",
			selectAddress: "选择用于交易的地址",
			dialog: {
				title: "创建策略机器人",
				description: "创建自动交易策略机器人的对话框",
				strategyGuide: "策略说明",
				limitStrategy: "挂单策略:",
				limitDescription: "在指定价格执行一次性买入或卖出操作",
				gridStrategy: "网格策略:",
				gridDescription: "在价格区间内自动低买高卖的网格交易",
				oneAddressRule: "每个交易地址同时只能运行一个策略机器人",
				sufficientBalance: "确保交易地址有足够的余额以执行策略",
			},
			select: "选择",
			buy: "买入",
			sell: "卖出",
			input: "输入",
			hasRunningBot: "已有运行中的机器人",
			poolId: "池ID",
			poolIdPlaceholder: "输入交易池ID（如：YjtR8zBoko）",
		},
		strategy: {
			type: "策略类型",
			parameters: "策略参数",
			noAvailable: "暂无可用策略",
			limit: {
				title: "挂单交易参数",
				side: {
					title: "操作类型",
				},
				price: {
					title: "目标价格",
					description: "执行交易的目标价格（Sats单位）",
				},
				amount: {
					title: "交易数量",
					description: "要交易的代币数量",
				},
			},
			grid: {
				title: "网格交易参数",
				priceMin: {
					title: "最低价格",
					description: "网格交易的价格下限（Sats单位）",
				},
				priceMax: {
					title: "最高价格",
					description: "网格交易的价格上限（Sats单位）",
				},
				gridCount: {
					title: "网格数量",
					description: "在价格区间内分割的网格数量",
				},
				totalInvestment: {
					title: "总投资额",
					description: "网格交易的总投资金额（Sats单位）",
					btcHint: "约等于 {btc} BTC",
				},
			},
		},
		validation: {
			selectStrategy: "请选择策略类型",
			enterBotName: "请输入机器人名称",
			selectAddress: "请选择交易地址",
			enterPoolId: "请输入池ID",
			addressHasBot:
				"该地址已有运行中的机器人，请先停止现有机器人或选择其他地址",
			requiredParam: "请填写必填参数：",
		},
		invite: {
			title: "BabyOdin 邀请返利空投活动",
			subtitle:
				"一次邀请，两份收益！奥丁交易返佣，宝贝购买返利，双重激励，赚不停！",
			inviteMethod: "邀请方法",
			inviteMethodDesc: "通过",
			inviteMethodDesc2: "邀请码，邀请朋友买入",
			inviteMethodDesc3: "。持仓7天，在返利发放前不能卖出。",
			inviteMethodNote: "注意：加入 LP 池子同样视为有效持仓！",
			rebateRules: "返利规则",
			rebateRulesDesc:
				"返利所有有效邀请者买入$BABYODIN总量的5%。发放时间：满足持仓要求后的 T+1 天（第二天）。",
			rebateRulesNote: "注意：若奖励低于 1 枚 $BABYODIN，将不予发放。",
			activityTime: "活动时间",
			startTime: "启动时间：",
			endTime: "结束时间：",
			startDate: "2025 年 7 月 17 日",
			endDate: "2025年7月24日",
			rebateView: "邀请返利空投查看",
			dailyStats: "每日数据统计",
			inviteData: "邀请数据",
			noData: "暂无数据",
			noDataDesc: "当前日期还没有邀请记录，快去邀请朋友参与吧！",
			month: "月",
			day: "日",
			loading: "加载中...",
			loadingSoldAccounts: "加载卖出账号信息中...",
			downloadDetailed: "下载详细数据",
			downloadSummary: "下载摘要数据",
			rank: "排名",
			inviter: "邀请者",
			totalBuyAccounts: "总购买账号",
			validBuyAccounts: "有效购买账号",
			validHoldingDays: "有效持仓天数",
			estimatedReward: "预计邀请奖励",
			viewDetails: "查看明细",
			hideDetails: "关闭明细",
			account: "账号",
			purchaseCount: "购买次数",
			totalPurchase: "购买总量",
			hasSold: "是否卖出",
			holding: "持仓",
			liquidityPool: "流动池",
			validPurchaseTotal: "有效购买总量",
			yes: "是",
			no: "否",
			days: "天",
			achieved7Days: "达成7天持仓",
		},
		plaza: {
			searchPlaceholder: "输入符文ID或名称，关键词即可进入对应符文社区",
			enterCommunity: "进入社区",
			searchResults: "搜索结果",
			searching: "搜索中...",
			searchFailed: "搜索失败",
			searchError: "搜索出错",
			noRunesFound: "未找到相关符文",
			featuredBadge: "精选",
			loginPrompt: "登录后查看收藏社区",
			login: "登录",
			myFavorites: "收藏的社区",
			noFavorites: "暂无收藏的社区",
			hotCommunities: "热门社区",
			noHotCommunities: "暂无热门社区",
			hotTokens: "高波动代币",
			noHotTokens: "暂无热门代币",
			hotMedia: "热门媒体",
			featuredBuildersTitle: "web3建设者精选",
			verified: "Verified",
			viewMore: "查看更多",
			noFeaturedBuilders: "暂无精选建设者，敬请期待。",
			loadFeaturedBuildersError: "数据加载出现问题",
			communityActivity: "社区动态",
			realtime: "实时",
			newMessages: "{count} 条新消息",
			twitterUpdates: "推特动态",
			latest: "最新",
			hot: "热门",
			viewOriginal: "点击查看原文 →",
			noTwitterUpdates: "暂无推特动态",
			holders: "持仓",
			comments: "评论",
			anonymous: "匿名用户",
			lowHoldings: "持仓不足",
			valuation: "估值",
			supported: "已助力",
			monthAgo: "{months}月",
			daysAgo: "{days}天",
			hoursAgo: "{hours}小时",
			minutesAgo: "{minutes}分钟",
			justNow: "刚刚",
			officialMedia: "ODIN.FUN官方媒体账号",
			founderShare: "ODIN.FUN创始人分享",
			ctoMedia: "BabyOdin DAO推特",
			communityMedia: "BabyOdin社区媒体",
			runeWar: "符文大战",
			runeWarDesc: "基于ODIN符文的策略对战游戏",
			strategy: "策略",
			odinTreasure: "奥丁宝藏",
			odinTreasureDesc: "探索神秘宝藏的冒险游戏",
			adventure: "冒险",
			runeArena: "符文竞技场",
			runeArenaDesc: "实时PVP符文对战竞技",
			competitive: "竞技",
			players: "玩家",
			rating: "评分",
			redFlashSell: "红色闪烁代表有卖出",
			blueFlashBuy: "蓝色闪烁代表有买入",
			sponsoredRankingBanner: "赞助冲榜横幅",
			supportRanking: "助力冲榜",
			support: "助力",
			generatingPoster: "生成中",
			promoMechanismTitle: "竞价推荐展示机制",
			promoDialogEyebrow: "Sponsored Ranking",
			promoMechanismLabel: "机制说明",
			promoMechanismDescriptionLine1:
				"BabyOdin DAO账号中，按持仓价值排名前 3 的社区代币将获得展示资格。",
			promoMechanismDescriptionLine2:
				"在到账当周内，已发射代币原则上不予使用；一周后，BabyOdin 基金会将根据实际情况酌情安排使用或支出。",
			promoTopThree: "当前前 3 名",
			promoRankingTab: "助力排名",
			promoRulesTab: "规则说明",
			promoRulesTitle: "规则说明",
			promoRankingHint: "已剔除 2rfi 与 btc，当前展示前 10 个可助力项目。",
			promoRankingEmpty: "暂无可展示的助力项目",
			foundationAccount: "DAO账号",
			foundationAccountHint: "完整身份信息",
			copyFoundationAccount: "复制DAO账号",
			copyFoundationAddress: "复制DAO地址",
			copyLabel: "复制",
			copySuccess:
				"您已复制成功，可以通过Odin.Fun或者Odin.Baby的内部转账功能进行助力冲榜。",
			copyFailed: "复制失败，请手动复制",
			boostNow: "我要助力",
			identityId: "身份ID",
		},
		notifications: {
			title: "通知中心",
			settings: "通知设置",
			preferences: "通知偏好",
			history: "通知历史",
			markAllRead: "全部已读",
			markAsRead: "标记为已读",
			noNotifications: "暂无通知",
			noNotificationsDesc: "您的挂单和价格预警通知将在这里显示",
			loadingNotifications: "加载通知中...",
			orderCompleted: "🎉 挂单成交通知",
			orderFailed: "❌ 挂单执行失败",
			orderCancelled: "🔄 挂单已取消",
			priceAlert: "📈 价格预警触发",
			systemNotification: "🔔 系统通知",
			justNow: "刚刚",
			hoursAgo: "{hours}小时前",
			daysAgo: "{days}天前",
			clickToView: "点击查看详情",

			// 通知偏好设置
			settingsTitle: "🔔 通知设置",
			settingsSubtitle: "自定义您的通知偏好，及时获得重要信息",
			contactInfo: "📧 联系方式",
			emailAddress: "邮箱地址",
			phoneNumber: "手机号码",
			emailPlaceholder: "输入您的邮箱地址",
			phonePlaceholder: "输入您的手机号码",
			emailRequired: "必填",
			phoneRequired: "必填",
			emailNote: "用于接收邮件通知",
			phoneNote: "用于接收短信通知",

			// 通知类型
			notificationTypes: "🔔 通知偏好",
			notificationTypesDesc: "选择您希望接收的通知类型和方式",
			orderCompletedName: "订单成交",
			orderCompletedDesc: "当您的挂单成功执行时",
			orderFailedName: "订单失败",
			orderFailedDesc: "当您的挂单执行失败时",
			orderCancelledName: "订单取消",
			orderCancelledDesc: "当您的挂单被取消时",
			priceAlertsName: "价格预警",
			priceAlertsDesc: "代币价格达到设定条件时",

			// 通知渠道
			inApp: "🔔 应用内通知",
			inAppDesc: "在网站内显示通知",
			email: "📧 邮件通知",
			emailDesc: "发送到您的邮箱",
			sms: "📱 短信通知",
			smsDesc: "发送到您的手机",

			// 重要性标识
			highImportance: "重要",
			normalImportance: "普通",

			// 推荐设置
			recommendedSettings: "💡 推荐设置",
			recommendedSettingsDesc: "为了不错过重要的交易信息，我们建议您：",
			recommendation1: "开启订单成交和失败的应用内通知",
			recommendation2: "为重要失败（如余额不足）开启短信通知",
			recommendation3: "设置邮箱以便接收详细的成交确认",

			// 操作按钮
			save: "保存设置",
			saving: "保存中...",
			reset: "重置",
			cancel: "取消",

			// 成功/错误消息
			saveSuccess: "✅ 设置保存成功",
			saveSuccessDesc: "您的通知偏好已更新",
			saveError: "❌ 保存失败",
			saveErrorDesc: "请稍后重试",
			loadError: "❌ 加载设置失败",
			loadErrorDesc: "请刷新页面重试",
			emailRequiredDesc: "启用邮件通知需要提供有效的邮箱地址",
			phoneRequiredDesc: "启用短信通知需要提供有效的手机号码",

			// 帮助信息
			helpTitle: "💡 使用帮助",
			inAppHelp: "🔔 应用内通知",
			inAppHelpDesc: [
				"在网站右上角显示通知图标",
				"点击查看详细通知内容",
				"支持跳转到相关页面",
			],
			emailHelp: "📧 邮件通知",
			emailHelpDesc: [
				"发送到您绑定的邮箱",
				"包含详细的交易信息",
				"重要事件会延迟5分钟发送",
			],
			smsHelp: "📱 短信通知",
			smsHelpDesc: [
				"发送到您绑定的手机",
				"仅用于重要失败事件",
				"简洁的文字提醒",
			],
			privacyHelp: "🛡️ 隐私保护",
			privacyHelpDesc: [
				"联系信息加密存储",
				"可随时修改或删除",
				"不会发送营销信息",
			],
		},
		flashTrading: {
			title: "闪屏刷单",
			subtitle: "自动化小额交易系统",
			amount: "金额",
			btc: "BTC",
			usdValue: "约 ${value} USD",
			minimumAmount: "最低交易金额: 0.000006 BTC (600 sats)",
			largeAmountWarning: "⚠️ 金额较大，建议小额刷单",

			// 配置界面
			mode: "模式",
			buyOnlyMode: "只买入",
			sellOnlyMode: "只卖出",
			buySellCycleMode: "买卖循环",
			trigger: "触发",
			fixedInterval: "固定",
			idleDetection: "无交易",
			times: "次数",
			seconds: "秒",
			minutes: "分钟",

			// 按钮
			advancedSettings: "高级设置",
			startFlashTrading: "开始刷单",
			running: "运行中",

			// 监控界面
			flashTradingMonitor: "刷单监控",
			runningStatus: "🟢 运行中",
			pausedStatus: "⏸️ 已暂停",
			pause: "暂停",
			continue: "继续",
			stop: "停止刷单",

			// 统计信息
			executionProgress: "执行进度",
			successful: "成功",
			failed: "失败",
			afterTrigger: "后触发",
			afterExecution: "后执行",

			// 配置信息
			nextAction: "→",
			buyAction: "↑买入",
			sellAction: "↓卖出",
			intervalTrigger: "{seconds}秒",
			idleTrigger: "{minutes}分钟无交易",
			latestTransaction: "最新交易:",

			// 高级设置
			advancedSettingsTitle: "闪屏刷单高级设置",
			tradingMode: "交易模式",
			buyOnlyTitle: "只买入模式",
			buyOnlyDesc: "仅执行买入操作，增加买入压力",
			sellOnlyTitle: "只卖出模式",
			sellOnlyDesc: "仅执行卖出操作，持续制造卖出成交",
			buySellCycleTitle: "买卖循环模式",
			buySellCycleDesc: "交替执行买卖，保持活跃度",

			triggerMethod: "触发方式",
			fixedIntervalTitle: "固定间隔",
			fixedIntervalDesc: "按固定时间间隔执行交易",
			idleDetectionTitle: "无交易时间",
			idleDetectionDesc: "距离最新交易达到间隔时间时执行",

			executionInterval: "执行间隔（秒）",
			idleInterval: "无交易间隔时间（分钟）",
			maxExecutions: "最大执行次数",

			customInterval: "自定义 1-3600 秒",
			customIdleInterval: "自定义间隔（1-60分钟）",
			customMaxTrades: "自定义最大次数（1-10000次）",

			// 操作按钮
			cancel: "取消",
			confirm: "确定",
			save: "保存设置",

			// 提示信息
			mobileStarted: "刷单已启动",
			mobileDesc: "移动端监控界面将在独立窗口中显示，您可以关闭此配置窗口。",
			gotIt: "知道了",

			// 警告
			confirmClose: "刷单正在运行中，关闭将停止刷单。确定要关闭吗？",
			noTokenPrice: "当前代币价格不可用，暂时无法卖出",
			insufficientTokenBalance: "代币余额不足，无法执行只卖出模式",
			insufficientCycleBalance: "代币余额不足，无法执行买卖循环模式",
			tradingAmountAlert: "交易金额提醒",
			continueConfig: "继续配置",

			// 错误信息
			enterValidAmount: "请输入有效的交易金额",
			insufficientBalance: "BTC余额不足",
			minimumSellAmount: "最低卖出价值: 0.000005 BTC 等值",
			largeAmount: "交易金额 {amount} BTC 较大，建议使用小额进行刷单",
		},

		// 抢跑机器人
		frontrunner: {
			title: "抢跑机器人",
			subtitle: "自动监控并抢先购买新发行的符文代币",

			// 策略类型
			notConfigured: "未配置",
			targetedFollowing: "定向跟单",
			conservative: "保守型",
			aggressive: "激进型",
			custom: "自定义",
			configured: "已配置",

			// 模式
			simulationMode: "模拟模式",
			realMode: "真实模式",
			currentModeSimulation: "当前为模拟模式",
			simulationModeDesc:
				"所有交易均为模拟操作，不会产生实际交易。您可以在此模式下测试和优化您的策略。",

			// 控制按钮
			startMonitoring: "开始监控",
			stopMonitoring: "停止监控",
			reset: "重置",
			strategyConfig: "策略配置",

			// 状态信息
			monitoring: "监控中",
			stopped: "已停止",
			monitorDuration: "监控时长",
			mintCount: "Mint",
			buyCount: "买入",
			skipCount: "跳过",
			btcBalance: "BTC余额",

			// 监控配置
			monitorConfig: "监控配置",
			pollInterval: "轮询间隔",
			batchSize: "批次大小",

			// 持仓信息
			positions: "持仓",
			activePositions: "活跃持仓",
			historyPositions: "历史持仓",
			suggestions: "智能建议",
			holding: "持有中",
			selling: "卖出中",
			sold: "已卖出",
			pending: "待确认",
			profit: "盈亏",
			holdingTime: "持仓时间",
			currentPrice: "当前价格",
			buyPrice: "买入价格",
			sell: "卖出",

			// 监控流
			monitorStream: "监控流",
			allTrades: "全部交易",
			positionTrades: "持仓交易",
			mint: "铸造",
			buy: "买入",
			skip: "跳过",
			error: "错误",

			// 时间选择器
			selectTimeRange: "选择监控时间范围",
			last1Hour: "最近1小时",
			last3Hours: "最近3小时",
			last6Hours: "最近6小时",
			last12Hours: "最近12小时",
			last24Hours: "最近24小时",

			// 策略配置
			quickStrategy: "快速策略配置",
			creatorFilter: "创建者过滤",
			tickerFilter: "Ticker过滤",
			socialFilter: "社交媒体过滤",
			tradingSettings: "交易设置",

			creatorMode: "创建者模式",
			allCreators: "所有创建者",
			whitelist: "白名单",
			blacklist: "黑名单",

			tickerEnabled: "启用Ticker过滤",
			tickerMode: "过滤模式",
			includeMode: "包含模式",
			excludeMode: "排除模式",
			keywords: "关键词",
			caseSensitive: "区分大小写",

			requireTwitter: "需要Twitter",
			requireTelegram: "需要Telegram",
			requireWebsite: "需要网站",
			requireAny: "需要任意一个",

			buyAmount: "买入金额",
			maxPositions: "最大持仓数",
			targetProfit: "目标收益率",
			slippage: "滑点",

			save: "保存",
			cancel: "取消",
			settings: "设置",

			// 提示信息
			pleaseConfigStrategy: "请先配置策略后再开始监控",
			pleaseStopBeforeSwitch: "请先停止监控再切换模式",

			// 单位
			btc: "BTC",
			sats: "Sats",
			token: "token",
			minute: "分钟",
			minutes: "分钟",
			hour: "小时",
			hours: "小时",
			day: "天",
			justNow: "刚刚",

			// 交易类型
			tradeType: "类型",
			user: "用户",
			tokenName: "代币",
			btcAmount: "BTC量",
			tokenAmount: "代币量",
			price: "价格",

			// 过滤相关
			noLimit: "无限制",
			noRequirement: "无要求",
			requireAnyOne: "需要任意一个",
			creatorWhitelist: "白名单",
			creatorBlacklist: "黑名单",
			official: "官网",
			keyword: "个关键词",
			singleBuyAmount: "单笔买入",
			targetProfitRate: "目标涨幅",
			maxHoldingPositions: "最大持仓",
			refreshBalance: "刷新余额",

			// 事件相关
			simulatedBuySuccess: "模拟买入成功",
			buySuccess: "买入成功",
			simulatedSellSuccess: "模拟卖出成功",
			sellSuccess: "卖出成功",
			skipReason: "跳过",
			notMeetStrategy: "不符合策略",
			errorOccurred: "错误",
			unknownError: "未知错误",
			unknownOperation: "未知操作",
			waitingForChainEvents: "等待链上事件...",
			clickToStartMonitoring: "点击开始监控来查看实时事件",
			monitoringStatus: "监控中",
			totalRecords: "共 {count} 条记录",

			// 持仓相关
			waitingConfirmation: "等待确认",
			confirmingOrder: "订单确认中",
			submittingBuyOrder: "正在提交买入订单...",
			submittingSellOrder: "正在提交卖出订单...",
			buyOrderSubmitted: "买入订单已提交",
			sellOrderSubmitted: "卖出订单已提交",
			buyFailed: "买入失败",
			sellFailed: "卖出失败",

			// 策略配置相关
			creatorFilterLabel: "创建者过滤",
			socialRequirement: "社交要求",
			tickerFilterLabel: "Ticker过滤",
			tradingSettingsLabel: "交易设置",
			includeKeywords: "包含",
			excludeKeywords: "排除",

			// 风险提示
			realModeWarning: "真实模式风险提示",
			realModeWarningContent:
				"您即将进入真实交易模式，所有交易将真实执行并产生资金变动。请确保您已经充分了解相关风险。",
			understand: "我已了解",

			// 其他
			loginRequired: {
				title: "请先登录",
				description: "使用抢跑机器人需要先连接钱包",
			},

			// IntegratedPositionsCard相关
			strategyTooStrict: "策略过于严格",
			suggestTightenStrategy: "建议收紧策略",
			hitRate: "命中率",
			simulatedSell: "模拟卖出",
			immediateSell: "立即卖出",
			positionCount: "持仓",
			completed: "完成",
			profitShort: "盈",
			loss: "亏",
			thisExecutionStats: "本次执行统计数据",
			smartSuggestionsOptimization: "智能建议和策略优化",
			noDataYet: "暂无数据",

			// MobilePositionsCard相关
			noActivePositions: "暂无活跃持仓",
			noHistoryPositions: "暂无历史记录",
		},
		pwa: {
			installTitle: "安装应用",
			installDescription: "将此应用安装到您的主屏幕，获得更好、更快且支持离线使用的体验。",
			installButton: "立即安装",
			installGuideHint: "安装到桌面，像 App 一样更快打开。",
			iosInstallTitle: "安装应用",
			iosInstallDescription: "点击分享按钮并选择“添加到主屏幕”，以获得最佳体验。",
			pageLoadWaitingDescription: "请等待页面加载完成后再安装应用。",
			androidCheckingDescription: "正在检测浏览器安装能力，请稍候并保持页面交互…",
			androidInstallPendingDescription: "安装请求已提交，Android 可能还需要几秒钟完成应用生成。请先稍候，不要立即关闭页面。",
			androidInstallDescription: "暂未检测到浏览器原生安装弹窗，请先通过浏览器菜单完成安装。",
			androidInstallReadyDescription: "已检测到可直接安装，现在可以一键安装到桌面。",
			androidInstallInstruction: "点击右上角菜单，选择“安装应用”或“添加到主屏幕”。",
			androidInstallFailedDescription: "安装请求已被接受，但暂时没有检测到已安装应用。请到应用抽屉或系统搜索中查找 Odin；如果仍然没有，请重试安装。",
			androidInstallRetryInstruction: "建议先完全关闭当前标签页，再重新打开页面后重试；也可以改用 Chrome 浏览器菜单中的“安装应用”。",
			genericInstallDescription: "请通过浏览器菜单将本应用添加到主屏幕，以获得 App 体验。",
			genericInstallInstruction: "打开浏览器菜单，选择“添加到主屏幕”或类似选项。",
			openInChrome: "在 Chrome 中打开",
			copyLink: "复制链接",
			linkCopied: "链接已复制",
			inAppBrowserWarning: "由于应用限制，无法直接打开",
			openInBrowserInstruction: "请点击右上角菜单，选择在浏览器中打开",
		},
		settings: {
			title: "设置",
			theme: "主题",
			themeToggle: "明亮 / 暗黑",
			language: "语言",
			links: "链接",
			installApp: "安装应用",
			vipBenefits: "VIP权益",
			buyToken: "购买 $BABYODIN",
			memeLibrary: "Meme 资源库",
			whitepaper: "白皮书",
		},
		view: {
			title: "视图模式",
			standard: "社区版",
			standardDesc: "广场视角，发现热门趋势",
			pro: "专业版",
			proDesc: "数据视角，掌握全量波动",
			focus: "项目版",
			focusDesc: "项目视角，追踪特定代币",
			setting: "项目设置",
			searchPlaceholder: "输入 Token ID、名称或代码...",
			guideHint: "在这里切换“广场 / 数据 / 项目”视角",
			guideAction: "知道了",
			switchSuccess: "已切换至 {mode}",
		},
		event: {
			title: "OdinFun 0401 事件追踪",
			subtitle: "Odin.Baby 根据链上记录追踪整理制作，仅供参考。如有错漏，欢迎指正。",
			description: [
				"04-01 07:35 - 约 30 个代币（含 BURRITO/CRYPTOBURG）出现异常协同抛售。",
				"04-01 08:24 - 发现潜在漏洞风险，关闭平台提现功能。",
				"最新进展 - 已锁定攻击者地址，大部分用户资金安全，正与执法部门协同追回。"
			],
			sections: {
				odin: "OdinFun 平台追踪",
				icp: "ICP 链上追踪",
				btc: "BTC 链上追踪"
			},
			labels: {
				hackerId: "疑似黑客OdinFun账号",
				accountA: "账号A",
				accountB: "账号B",
				ckBtcAddress: "OdinFun 平台 ckBTC 地址",
				hackerBtcAddress: "疑似黑客汇集 BTC 地址",
				transferHub: "中转地址",
				eventExtractedBtcAddresses: "0401事件提取BTC汇集地址",
				internalTransfers: "收到内部转账记录",
				withdrawals: "提现记录",
				withdrawerInfo: "提现者信息",
				filterLabel: "筛选",
				hackerAddressFilter: "疑似黑客地址",
				otherAddressFilter: "其他地址",
				hackerAddressStats: "疑似黑客地址",
				otherAddressStats: "其他地址",
				accountCount: "涉及账号数",
				recordCount: "记录数",
				totalBtc: "合计 BTC",
				totalUsd: "折合美元",
				totalAmount: "总计金额",
				balance: "当前余额",
				historicalReceived: "历史收到",
				allTransferred: "已全部转移",
				transactions: "交易记录",
				loading: "加载中...",
				noData: "暂无相关数据",
				stats: "数据统计",
				financialOverview: "资金动向概览",
				largeWithdrawalTracking: "大额提现追踪",
				attackerIdentity: "疑似攻击者身份识别",
				securityProtocol: "安全监控协议",
				time: "时间",
				index: "序号",
				timestamp: "时间戳",
				amountCkBtc: "数量 (ckBTC)",
				recipient: "接收地址",
				action: "操作",
				usdValue: "美元价值",
				confirmedStatus: "已确认",
				pendingStatus: "待确认",
				blockstreamLive: "Blockstream 实时",
				initializingTrackerData: "正在初始化追踪数据...",
				loadingWithdrawalData: "正在加载提现数据...",
				senderInfo: "发送者信息",
				amountBtc: "BTC 数量",
				withdrawalAddress: "提现地址",
				btcMainnet: "BTC主网",
				btcMainnetNode: "BTC主网",
				hackerBtcNode: "疑似黑客BTC地址",
				transfer: "转账",
				withdrawToBtcMainnet: "提现至BTC主网",
				transferId: "转账ID",
				paginationSummary: "{start}-{end} / {total}",
				hackerAppeal: "重要提示：我们已掌握攻击者的交易所账号信息及关联身份。请尽快联系 @BobBodily 协商 White-hat 白帽解决方案，以免进一步法律追责。",
				viewAppealDetail: "查看详细公告",
				victimAppealTitle: "Odin社区联合行动倡议",
				victimAppealDesc: "呼吁所有 Odin社区 成员联合起来，追踪资产动向，分享关键线索，全力协助 OdinFun 团队追回资金。",
				groupName: "OdinFun0401事件追踪",
				qqGroupLabel: "QQ群：",
				oneClickJoin: "一键入群",
				copyGroupId: "复制群号",
				groupId: "470786182",
				largeWithdrawalNote: "此处仅展示追踪两笔大额提现，更多追踪方法请参考 {link}"
			}
		},
	},
	en: {
		title: "Baby Tyche",
		subtitle: "Fortune Vault Lottery Search",
		searchPlaceholder:
			"Enter Token ID, name or ticker to check lottery results...",
		searchButton: "Search",
		searching: "Searching...",
		gameMechanics: "Game Mechanics",
		fateVault: "Fate Vault",
		searchInfo: "Enter your Token ID, name or ticker to check if you won",
		luckMessage: "Baby Tyche brings you good luck 🍀",
		copyright: "© 2024 Baby Tyche. All rights reserved.",
		searchAlert: "Search Token ID:",
		announcement: "Trade Monitoring Page Now Live!",
		checkWinning: "Check Winning",
		checkData: "Check Data",
		priceChanges: "Price Changes",
		newListings: "New Listings",
		upcomingLottery: "Upcoming Lottery",
		marketCapRank: "Market Cap Rank",
		priceRank: "Price Rank",
		switchToMarketCap: "Switch to Market Cap",
		switchToPrice: "Switch to Price Rank",
		liquidityRank: "Liquidity Rank",
		switchToLiquidity: "Switch to Liquidity Rank",
		lpShare: "LP Share",
		noMarketCapTokens: "No market cap data available",
		autoRefresh: "Auto refresh every 3s",
		trades: "Trades",
		marketCap: "MarketCap",
		marketCapPrefix: "MarketCap:",
		holdingsPrefix: "Holdings:",
		chartOpen: "Open",
		chartHigh: "High",
		chartLow: "Low",
		chartClose: "Close",
		chartVolume: "Volume",
		noResults: "No lottery records found",
		ceremony: "Round {round} Draw",
		milestones: [
			"50% Stage",
			"60% Stage",
			"70% Stage",
			"80% Stage (Graduation)",
		],
		totalPool: "Total Pool",
		distributed: "Distributed",
		rollover: "Rollover",
		firstPrize: "1st Prize",
		secondPrize: "2nd Prize",
		thirdPrize: "3rd Prize",
		winners: "Winners",
		amount: "Amount",
		backToSearch: "Back to Search",
		pending: "Pending",
		completed: "Completed",
		allCompleted: "All lottery rounds completed",
		partialCompleted: "{completed} / 4 rounds completed",
		waitingForNext: "Waiting for next round",
		userSearchPlaceholder: "Enter user Principal to check winning records...",
		userSearch: "Check Wins",
		userSearching: "Checking...",
		createdAt: "Created",
		status: "Status",
		description: "Description",
		links: "Links",
		website: "Website",
		twitter: "Twitter",
		tributeRatio: "Tribute Ratio",
		tribute: "Tribute",
		fateVaultContribution: "Fate Vault Contribution",
		lotteryProgress: "Lottery Progress",
		milestone50: "50%",
		milestone60: "60%",
		milestone70: "70%",
		milestone80: "80%",
		prize1st: "1st Prize",
		prize2nd: "2nd Prize",
		prize3rd: "3rd Prize",
		telegram: "Telegram",
		graduated: "Graduated",
		primary: "Primary",
		upcomingRound: "Round {round} upcoming",
		dataFrom: "Data from",
		realtime: "Real-time",
		cache: "Cache",
		apiCallFailed: "API call failed:",
		failedToGetTokenInfo: "Failed to get token info:",
		tokenInfo: "Token info:",
		isFromCache: "Is from cache:",
		userWinResults: "User Winning Records",
		noWinRecords: "This user has no winning records",
		winRecord: "Winning Record",
		tokenNotFound: "Token not found or failed to load.",
		creator: "Creator",
		buyShort: "B",
		sellShort: "S",
		totalShort: "T",
		round: "Round {round}",
		rank: "Prize",
		clearSearch: "Clear Search",
		totalWinnings: "Total Winnings",
		nav: {
			home: "Home",
			monitor: "Monitor",
			address: "Address",
			trade: "Trade",
			airdrop: "Airdrop",
			invite: "Invite",
			tools: "Tools",
			activities: "Activities",
			plaza: "Plaza",
			data: "Data",
			scan: "Monitor",
			toolsMenu: {
				oneClickAirdrop: "One-click Airdrop",
				internalTransfer: "Internal Transfer Browser",
				batchAirdrop: "Batch Airdrop",
				singleTransfer: "Single Transfer",
				frontrunner: "Frontrunner Bot",
				runeAddress: "Odin-Fomowell Address Links",
				web3BuildersAlliance: "Web3 Builders Alliance",
			},
			activitiesMenu: {
				babyOdinAirdrop: "BabyOdin Airdrop",
				babyOdinInvite: "BabyOdin Invite",
			},
		},
		trade: {
			buy: "Buy",
			sell: "Sell",
			auto: "Auto",
			autoTrading: "Auto Trading",
			comingSoon: "Coming soon...",
			buySuccess: "Buy successful",
			sellSuccess: "Sell successful",
			txFailed: "Transaction failed",
		},
		wallet: {
			connect: "Connect Wallet",
			connecting: "Connecting...",
			connected: "Connected",
			disconnect: "Disconnect",
			connectSuccess: "Wallet connected successfully!",
			connectError: "Connection failed",
			notInstalled: "Wallet not installed",
			clickToInstall: "Click to Install",
			selectWallet: "Select Wallet",
			myProfile: "My Profile",
			sendBTC: "Send BTC",
			btcAddress: "BTC Address",
			identityId: "Identity ID",
			copyAddress: "Copy Address",
			copyId: "Copy ID",
			copied: "Copied",
			mainnetConnected: "Mainnet Connected",
		},
		sendBtc: {
			title: "Send BTC to User",
			subtitle:
				"Send BTC instantly to another user by entering their Tyche ID.",
			availableBalance: "Available Balance:",
			recipientLabel: "Recipient Tyche ID",
			recipientPlaceholder: "Enter recipient's Tyche ID",
			formatHint:
				"Format: ff6ae-c2252-skzbs-25ekh-qrjpj-wumpy-orxeg-ijzjs-hx6gj-3ot35-axa",
			amountLabel: "Amount (BTC)",
			amountPlaceholder: "0.00000000",
			maxButton: "Max",
			minimumAmount: "Minimum 0.0001 BTC",
			fee: "Fee: 10 sats",
			cancel: "Cancel",
			back: "Back",
			reviewSend: "Review & Send",
			send: "Send",
			sending: "Sending...",
			confirmTitle: "Confirm Transaction",
			to: "To:",
			amount: "Amount:",
			usdValue: "USD Value:",
			feeLabel: "Fee:",
			total: "Total:",
		},
		auth: {
			signIn: "Sign In",
			signOut: "Sign Out",
			signInWith: "Sign in with {provider}",
			selectProvider: "Select Sign-In Method",
			telegram: "Telegram",
			okxWallet: "OKX Wallet",
			cancel: "Cancel",
			signInDescription:
				"Choose your preferred sign-in method to access your account",
			dashboard: "Profile",
			myBtcAddresses: "My BTC Addresses",
			loading: "Loading...",
			or: "or",
		},
		loading: "Loading...",
		userInfo: "User Information",
		user: "User",
		joinedDate: "Joined",
		authMethods: "Authentication Methods",
		link: "Link",
		linkedAt: "Linked",
		btcAddresses: "BTC Addresses",
		addressIsBot: "Each address is a bot",
		total: "total",
		generate: "Generate",
		addressCreatedAt: "Created",
		noBtcAddresses: "No BTC addresses yet",
		generateFirstAddress: "Generate your first address",
		botStatus: "Bot Status",
		botStatusDesc: "Current running strategy bots",
		noActiveBots: "No active bots",
		botStatusHint: "Bot status will be displayed here",
		accountLogs: "Account Logs",
		accountLogsDesc: "Your recent account activities",
		noActivityLogs: "No activity logs",
		default: "Default",
		trading: {
			slippage: "Slippage",
			balance: "Balance",
			pay: "Pay",
			receive: "Receive",
			priceImpact: "Price Impact",
			swap: "Swap",
			swapping: "Swapping...",
			swapSuccess: "Swap successful",
			swapFailed: "Swap failed",
			insufficientBalance: "Insufficient balance",
			selectBot: "Select Bot",
			noBots: "No bots available",
			loadingBots: "Loading bots...",
			refresh: "Refresh",
			assets: "Assets",
			txHistory: "Transaction History",
			noTxHistory: "No transaction history",
			failedToLoadBots: "Failed to load bots",
			failedToLoadAssets: "Failed to load assets",
			failedToLoadTxHistory: "Failed to load transaction history",
			failedToGetQuote: "Failed to get quote",
			trade: "Trade",
			limitOrder: "Limit Order",
			buy: "Buy",
			sell: "Sell",
			tokensReceived: "Tokens Received",
			btcReceived: "BTC Received",
			enterValidAmount: "Enter Valid Amount",
			processing: "Processing...",
			pleaseLogin: "Please Login",
		},
		liquidity: {
			liquidityPool: "Liquidity Pool",
			add: "Add",
			remove: "Remove",
			addLiquidity: "Add Liquidity",
			removeLiquidity: "Remove Liquidity",
			yourLiquidity: "Your Liquidity",
			poolShare: "Pool Share",
			requiredToken: "Required Token",
			depositRatio: "Deposit Ratio",
			btcReceived: "BTC Received",
			tokenReceived: "Token Received",
			addSuccess: "Add liquidity successful",
			removeSuccess: "Remove liquidity successful",
			addFailed: "Add liquidity failed",
			removeFailed: "Remove liquidity failed",
			operationFailed: "Operation failed",
			totalDeposit: "Total Deposit",
			noLiquidity: "No liquidity",
		},
		bot: {
			create: "Create Strategy Bot",
			createButton: "Create Bot",
			creating: "Creating...",
			name: "Bot Name",
			namePlaceholder: "Give your bot a name",
			tradingAddress: "Trading Address",
			selectAddress: "Select address for trading",
			dialog: {
				title: "Create Strategy Bot",
				description: "Dialog for creating automated trading strategy bots",
				strategyGuide: "Strategy Guide",
				limitStrategy: "Limit Strategy:",
				limitDescription: "Execute one-time buy/sell at specified price",
				gridStrategy: "Grid Strategy:",
				gridDescription: "Automated buy low, sell high within price range",
				oneAddressRule:
					"Each trading address can only run one strategy bot at a time",
				sufficientBalance: "Ensure sufficient balance in trading address",
			},
			select: "Select",
			buy: "Buy",
			sell: "Sell",
			input: "Enter",
			hasRunningBot: "Has running bot",
			poolId: "Pool ID",
			poolIdPlaceholder: "Enter trading pool ID (e.g.: YjtR8zBoko)",
		},
		strategy: {
			type: "Strategy Type",
			parameters: "Strategy Parameters",
			noAvailable: "No available strategies",
			limit: {
				title: "Limit Order Parameters",
				side: {
					title: "Order Type",
				},
				price: {
					title: "Target Price",
					description: "Target price for executing the trade (Sats unit)",
				},
				amount: {
					title: "Trade Amount",
					description: "Amount of tokens to trade",
				},
			},
			grid: {
				title: "Grid Trading Parameters",
				priceMin: {
					title: "Minimum Price",
					description: "Lower bound for grid trading (Sats unit)",
				},
				priceMax: {
					title: "Maximum Price",
					description: "Upper bound for grid trading (Sats unit)",
				},
				gridCount: {
					title: "Grid Count",
					description: "Number of grids to divide within the price range",
				},
				totalInvestment: {
					title: "Total Investment",
					description: "Total investment amount for grid trading (Sats unit)",
					btcHint: "Approximately {btc} BTC",
				},
			},
		},
		validation: {
			selectStrategy: "Please select a strategy type",
			enterBotName: "Please enter a bot name",
			selectAddress: "Please select a trading address",
			enterPoolId: "Please enter a pool ID",
			addressHasBot:
				"This address already has a running bot, please stop the existing bot or select another address",
			requiredParam: "Please fill in the required parameter: ",
		},
		invite: {
			title: "BabyOdin Invite Rebate Airdrop Event",
			subtitle:
				"One invite, double rewards! Odin trading rebates, Baby purchase cashback, double incentives, endless earnings!",
			inviteMethod: "How to Invite",
			inviteMethodDesc: "Through",
			inviteMethodDesc2: "invite code, invite friends to buy",
			inviteMethodDesc3:
				". Hold for 7 days, cannot sell before rebate distribution.",
			inviteMethodNote: "Note: Adding to LP pool also counts as valid holding!",
			rebateRules: "Rebate Rules",
			rebateRulesDesc:
				"5% rebate on total $BABYODIN purchased by all valid invitees. Distribution time: T+1 day (next day) after meeting holding requirements.",
			rebateRulesNote:
				"Note: Rewards below 1 $BABYODIN will not be distributed.",
			activityTime: "Activity Period",
			startTime: "Start Time:",
			endTime: "End Time:",
			startDate: "July 17, 2025",
			endDate: "July 24, 2025",
			rebateView: "View Invite Rebate Airdrop",
			dailyStats: "Daily Statistics",
			inviteData: "Invitation Data",
			noData: "No Data",
			noDataDesc:
				"No invitation records for this date, invite your friends to participate!",
			month: " ",
			day: "",
			loading: "Loading...",
			loadingSoldAccounts: "Loading sold accounts info...",
			downloadDetailed: "Download Detailed Data",
			downloadSummary: "Download Summary Data",
			rank: "Rank",
			inviter: "Inviter",
			totalBuyAccounts: "Total Buy Accounts",
			validBuyAccounts: "Valid Buy Accounts",
			validHoldingDays: "Valid Holding Days",
			estimatedReward: "Estimated Reward",
			viewDetails: "View Details",
			hideDetails: "Hide Details",
			account: "Account",
			purchaseCount: "Purchase Count",
			totalPurchase: "Total Purchase",
			hasSold: "Has Sold",
			holding: "Holding",
			liquidityPool: "Liquidity Pool",
			validPurchaseTotal: "Valid Purchase Total",
			yes: "Yes",
			no: "No",
			days: "days",
			achieved7Days: "Achieved 7-day holding",
		},
		plaza: {
			searchPlaceholder:
				"Enter rune ID or name, keywords to enter the corresponding rune community",
			enterCommunity: "Enter Community",
			searchResults: "Search Results",
			searching: "Searching...",
			searchFailed: "Search failed",
			searchError: "Search error",
			noRunesFound: "No related runes found",
			featuredBadge: "Featured",
			loginPrompt: "Login to view favorite communities",
			login: "Login",
			myFavorites: "My Favorites",
			noFavorites: "No favorite communities yet",
			hotCommunities: "Hot Communities",
			noHotCommunities: "No hot communities available",
			hotTokens: "High Volatility Tokens",
			noHotTokens: "No hot tokens available",
			hotMedia: "Hot Media",
			featuredBuildersTitle: "Featured Web3 Builders",
			verified: "Verified",
			viewMore: "View More",
			noFeaturedBuilders: "No featured builders yet. Stay tuned.",
			loadFeaturedBuildersError: "There was a problem loading the data",
			communityActivity: "Community Activity",
			realtime: "Realtime",
			newMessages: "{count} new messages",
			twitterUpdates: "Twitter Updates",
			latest: "Latest",
			hot: "Hot",
			viewOriginal: "View original →",
			noTwitterUpdates: "No Twitter updates",
			holders: "Holders",
			comments: "Comments",
			anonymous: "Anonymous",
			lowHoldings: "Low Holdings",
			valuation: "Valuation",
			supported: "Supported",
			monthAgo: "{months} months",
			daysAgo: "{days} days",
			hoursAgo: "{hours} hours",
			minutesAgo: "{minutes} minutes",
			justNow: "Just now",
			officialMedia: "ODIN.FUN Official Media Account",
			founderShare: "ODIN.FUN Founder Share",
			ctoMedia: "BabyOdin Foundation Media",
			communityMedia: "BabyOdin Community Media",
			runeWar: "Rune War",
			runeWarDesc: "Strategy battle game based on ODIN runes",
			strategy: "Strategy",
			odinTreasure: "Odin Treasure",
			odinTreasureDesc: "Adventure game exploring mysterious treasures",
			adventure: "Adventure",
			runeArena: "Rune Arena",
			runeArenaDesc: "Real-time PVP rune battle competition",
			competitive: "Competitive",
			players: "Players",
			rating: "Rating",
			redFlashSell: "Red flash represents sell orders",
			blueFlashBuy: "Blue flash represents buy orders",
			sponsoredRankingBanner: "Sponsored ranking banner",
			supportRanking: "Support Ranking",
			support: "Support",
			generatingPoster: "Generating",
			promoMechanismTitle: "Competitive Recommendation Display Mechanism",
			promoDialogEyebrow: "Sponsored Ranking",
			promoMechanismLabel: "Mechanism",
			promoMechanismDescriptionLine1:
				"The top 3 community tokens ranked by holding value in the BabyOdin foundation account will receive display eligibility.",
			promoMechanismDescriptionLine2:
				"During the week of arrival, launched tokens will generally not be used. After one week, the BabyOdin foundation may arrange usage or spending based on actual conditions.",
			promoTopThree: "Current Top 3",
			promoRankingTab: "Boost Ranking",
			promoRulesTab: "Rules",
			promoRulesTitle: "Rules",
			promoRankingHint:
				"2rfi and btc are excluded. Showing the current top 10 boostable projects.",
			promoRankingEmpty: "No boostable projects available right now",
			foundationAccount: "Foundation Account",
			foundationAccountHint: "Full identity card",
			copyFoundationAccount: "Copy Foundation Account",
			copyFoundationAddress: "Copy Foundation Address",
			copyLabel: "Copy",
			copySuccess:
				"Copied successfully. You can support the ranking through the internal transfer feature in Odin.Fun or Odin.Baby.",
			copyFailed: "Copy failed, please copy manually",
			boostNow: "Boost Now",
			identityId: "Identity ID",
		},
		notifications: {
			title: "Notification Center",
			settings: "Notification Settings",
			preferences: "Notification Preferences",
			history: "Notification History",
			markAllRead: "Mark All Read",
			markAsRead: "Mark as Read",
			noNotifications: "No notifications",
			noNotificationsDesc:
				"Your order and price alert notifications will appear here",
			loadingNotifications: "Loading notifications...",
			orderCompleted: "🎉 Order Completed",
			orderFailed: "❌ Order Failed",
			orderCancelled: "🔄 Order Cancelled",
			priceAlert: "📈 Price Alert",
			systemNotification: "🔔 System Notification",
			justNow: "Just now",
			hoursAgo: "{hours}h ago",
			daysAgo: "{days}d ago",
			clickToView: "Click to view details",

			// Notification preferences
			settingsTitle: "🔔 Notification Settings",
			settingsSubtitle:
				"Customize your notification preferences to stay informed",
			contactInfo: "📧 Contact Information",
			emailAddress: "Email Address",
			phoneNumber: "Phone Number",
			emailPlaceholder: "Enter your email address",
			phonePlaceholder: "Enter your phone number",
			emailRequired: "Required",
			phoneRequired: "Required",
			emailNote: "For email notifications",
			phoneNote: "For SMS notifications",

			// Notification types
			notificationTypes: "🔔 Notification Preferences",
			notificationTypesDesc:
				"Choose the types and methods of notifications you want to receive",
			orderCompletedName: "Order Completed",
			orderCompletedDesc: "When your limit order is successfully executed",
			orderFailedName: "Order Failed",
			orderFailedDesc: "When your limit order fails to execute",
			orderCancelledName: "Order Cancelled",
			orderCancelledDesc: "When your limit order is cancelled",
			priceAlertsName: "Price Alerts",
			priceAlertsDesc: "When token prices reach set conditions",

			// Notification channels
			inApp: "🔔 In-App Notification",
			inAppDesc: "Show notifications within the website",
			email: "📧 Email Notification",
			emailDesc: "Send to your email address",
			sms: "📱 SMS Notification",
			smsDesc: "Send to your phone",

			// Importance levels
			highImportance: "High",
			normalImportance: "Normal",

			// Recommended settings
			recommendedSettings: "💡 Recommended Settings",
			recommendedSettingsDesc:
				"To avoid missing important trading information, we recommend:",
			recommendation1:
				"Enable in-app notifications for order completed and failed",
			recommendation2:
				"Enable SMS notifications for critical failures (e.g., insufficient balance)",
			recommendation3:
				"Set up email to receive detailed execution confirmations",

			// Action buttons
			save: "Save Settings",
			saving: "Saving...",
			reset: "Reset",
			cancel: "Cancel",

			// Success/Error messages
			saveSuccess: "✅ Settings Saved Successfully",
			saveSuccessDesc: "Your notification preferences have been updated",
			saveError: "❌ Save Failed",
			saveErrorDesc: "Please try again later",
			loadError: "❌ Failed to Load Settings",
			loadErrorDesc: "Please refresh the page to retry",
			emailRequiredDesc:
				"A valid email address is required to enable email notifications",
			phoneRequiredDesc:
				"A valid phone number is required to enable SMS notifications",

			// Help information
			helpTitle: "💡 Help & Guide",
			inAppHelp: "🔔 In-App Notifications",
			inAppHelpDesc: [
				"Show notification icon in top right corner",
				"Click to view detailed notification content",
				"Support navigation to related pages",
			],
			emailHelp: "📧 Email Notifications",
			emailHelpDesc: [
				"Send to your registered email",
				"Include detailed transaction information",
				"Important events delayed by 5 minutes",
			],
			smsHelp: "📱 SMS Notifications",
			smsHelpDesc: [
				"Send to your registered phone",
				"Only for critical failure events",
				"Concise text reminders",
			],
			privacyHelp: "🛡️ Privacy Protection",
			privacyHelpDesc: [
				"Contact information encrypted storage",
				"Can be modified or deleted anytime",
				"No marketing messages will be sent",
			],
		},
		flashTrading: {
			title: "Flash Trading",
			subtitle: "Automated Micro Trading System",
			amount: "Amount",
			btc: "BTC",
			usdValue: "≈ ${value} USD",
			minimumAmount: "Minimum amount: 0.000006 BTC (600 sats)",
			largeAmountWarning: "⚠️ Large amount, recommend micro trading",

			// Configuration Interface
			mode: "Mode",
			buyOnlyMode: "Buy Only",
			sellOnlyMode: "Sell Only",
			buySellCycleMode: "Buy-Sell Cycle",
			trigger: "Trigger",
			fixedInterval: "Fixed",
			idleDetection: "Idle",
			times: "Times",
			seconds: "sec",
			minutes: "min",

			// Buttons
			advancedSettings: "Advanced Settings",
			startFlashTrading: "Start Flash Trading",
			running: "Running",

			// Monitor Interface
			flashTradingMonitor: "Flash Trading Monitor",
			runningStatus: "🟢 Running",
			pausedStatus: "⏸️ Paused",
			pause: "Pause",
			continue: "Continue",
			stop: "Stop Trading",

			// Statistics
			executionProgress: "Execution Progress",
			successful: "Success",
			failed: "Failed",
			afterTrigger: "to trigger",
			afterExecution: "to execute",

			// Configuration Info
			nextAction: "→",
			buyAction: "↑Buy",
			sellAction: "↓Sell",
			intervalTrigger: "{seconds}s",
			idleTrigger: "{minutes}min idle",
			latestTransaction: "Latest tx:",

			// Advanced Settings
			advancedSettingsTitle: "Flash Trading Advanced Settings",
			tradingMode: "Trading Mode",
			buyOnlyTitle: "Buy Only Mode",
			buyOnlyDesc: "Execute buy orders only to increase buying pressure",
			sellOnlyTitle: "Sell Only Mode",
			sellOnlyDesc: "Execute sell orders only to keep sell-side activity flowing",
			buySellCycleTitle: "Buy-Sell Cycle Mode",
			buySellCycleDesc: "Alternate buy/sell orders to maintain activity",

			triggerMethod: "Trigger Method",
			fixedIntervalTitle: "Fixed Interval",
			fixedIntervalDesc: "Execute trades at fixed time intervals",
			idleDetectionTitle: "Idle Detection",
			idleDetectionDesc:
				"Execute when idle time since last transaction is reached",

			executionInterval: "Execution Interval (seconds)",
			idleInterval: "Idle Detection Interval (minutes)",
			maxExecutions: "Maximum Executions",

			customInterval: "Custom 1-3600 seconds",
			customIdleInterval: "Custom interval (1-60 minutes)",
			noTokenPrice: "Token price unavailable, sell mode cannot start",
			insufficientTokenBalance: "Insufficient token balance for Sell Only mode",
			insufficientCycleBalance:
				"Insufficient token balance for Buy-Sell Cycle mode",
			customMaxTrades: "Custom max trades (1-10000)",

			// Action Buttons
			cancel: "Cancel",
			confirm: "Confirm",
			save: "Save Settings",

			// Notifications
			mobileStarted: "Flash Trading Started",
			mobileDesc:
				"Mobile monitor will display in independent window, you can close this config window.",
			gotIt: "Got It",

			// Warnings
			confirmClose:
				"Flash trading is running, closing will stop trading. Are you sure?",
			tradingAmountAlert: "Trading Amount Alert",
			continueConfig: "Continue Config",

			// Error Messages
			enterValidAmount: "Please enter a valid trading amount",
			insufficientBalance: "Insufficient BTC balance",
			minimumSellAmount: "Minimum sell value: 0.000005 BTC equivalent",
			largeAmount:
				"Trading amount {amount} BTC is large, recommend using small amounts for flash trading",
		},

		// Frontrunner Bot
		frontrunner: {
			title: "Frontrunner Bot",
			subtitle: "Automatically monitor and buy newly issued rune tokens",

			// Strategy Types
			notConfigured: "Not Configured",
			targetedFollowing: "Targeted Following",
			conservative: "Conservative",
			aggressive: "Aggressive",
			custom: "Custom",
			configured: "Configured",

			// Modes
			simulationMode: "Simulation Mode",
			realMode: "Real Mode",
			currentModeSimulation: "Currently in Simulation Mode",
			simulationModeDesc:
				"All trades are simulated, no real transactions will occur. You can test and optimize your strategy in this mode.",

			// Control Buttons
			startMonitoring: "Start Monitoring",
			stopMonitoring: "Stop Monitoring",
			reset: "Reset",
			strategyConfig: "Strategy Config",

			// Status Info
			monitoring: "Monitoring",
			stopped: "Stopped",
			monitorDuration: "Monitor Duration",
			mintCount: "Mint",
			buyCount: "Buy",
			skipCount: "Skip",
			btcBalance: "BTC Balance",

			// Monitor Config
			monitorConfig: "Monitor Config",
			pollInterval: "Poll Interval",
			batchSize: "Batch Size",

			// Position Info
			positions: "Positions",
			activePositions: "Active Positions",
			historyPositions: "History",
			suggestions: "Suggestions",
			holding: "Holding",
			selling: "Selling",
			sold: "Sold",
			pending: "Pending",
			profit: "P/L",
			holdingTime: "Holding Time",
			currentPrice: "Current Price",
			buyPrice: "Buy Price",
			sell: "Sell",

			// Monitor Stream
			monitorStream: "Monitor Stream",
			allTrades: "All Trades",
			positionTrades: "Position Trades",
			mint: "Mint",
			buy: "Buy",
			skip: "Skip",
			error: "Error",

			// Time Range Selector
			selectTimeRange: "Select Monitor Time Range",
			last1Hour: "Last 1 Hour",
			last3Hours: "Last 3 Hours",
			last6Hours: "Last 6 Hours",
			last12Hours: "Last 12 Hours",
			last24Hours: "Last 24 Hours",

			// Strategy Config
			quickStrategy: "Quick Strategy Config",
			creatorFilter: "Creator Filter",
			tickerFilter: "Ticker Filter",
			socialFilter: "Social Media Filter",
			tradingSettings: "Trading Settings",

			creatorMode: "Creator Mode",
			allCreators: "All Creators",
			whitelist: "Whitelist",
			blacklist: "Blacklist",

			tickerEnabled: "Enable Ticker Filter",
			tickerMode: "Filter Mode",
			includeMode: "Include Mode",
			excludeMode: "Exclude Mode",
			keywords: "Keywords",
			caseSensitive: "Case Sensitive",

			requireTwitter: "Require Twitter",
			requireTelegram: "Require Telegram",
			requireWebsite: "Require Website",
			requireAny: "Require Any",

			buyAmount: "Buy Amount",
			maxPositions: "Max Positions",
			targetProfit: "Target Profit",
			slippage: "Slippage",

			save: "Save",
			cancel: "Cancel",
			settings: "Settings",

			// Messages
			pleaseConfigStrategy: "Please configure strategy before monitoring",
			pleaseStopBeforeSwitch: "Please stop monitoring before switching mode",

			// Units
			btc: "BTC",
			sats: "Sats",
			token: "token",
			minute: "minute",
			minutes: "minutes",
			hour: "hour",
			hours: "hours",
			day: "day",
			justNow: "Just now",

			// Trade Types
			tradeType: "Type",
			user: "User",
			tokenName: "Token",
			btcAmount: "BTC Amt",
			tokenAmount: "Token Amt",
			price: "Price",

			// Filter Related
			noLimit: "No Limit",
			noRequirement: "No Requirement",
			requireAnyOne: "Require Any",
			creatorWhitelist: "Whitelist",
			creatorBlacklist: "Blacklist",
			official: "Official",
			keyword: " keywords",
			singleBuyAmount: "Buy Amount",
			targetProfitRate: "Target Profit",
			maxHoldingPositions: "Max Positions",
			refreshBalance: "Refresh Balance",

			// Event Related
			simulatedBuySuccess: "Simulated Buy Success",
			buySuccess: "Buy Success",
			simulatedSellSuccess: "Simulated Sell Success",
			sellSuccess: "Sell Success",
			skipReason: "Skip",
			notMeetStrategy: "Not Meet Strategy",
			errorOccurred: "Error",
			unknownError: "Unknown Error",
			unknownOperation: "Unknown Operation",
			waitingForChainEvents: "Waiting for chain events...",
			clickToStartMonitoring: "Click Start to view real-time events",
			monitoringStatus: "Monitoring",
			totalRecords: "{count} records total",

			// Position Related
			waitingConfirmation: "Waiting Confirmation",
			confirmingOrder: "Order Confirming",
			submittingBuyOrder: "Submitting buy order...",
			submittingSellOrder: "Submitting sell order...",
			buyOrderSubmitted: "Buy order submitted",
			sellOrderSubmitted: "Sell order submitted",
			buyFailed: "Buy Failed",
			sellFailed: "Sell Failed",

			// Strategy Config Related
			creatorFilterLabel: "Creator Filter",
			socialRequirement: "Social Requirement",
			tickerFilterLabel: "Ticker Filter",
			tradingSettingsLabel: "Trading Settings",
			includeKeywords: "Include",
			excludeKeywords: "Exclude",

			// Risk Warning
			realModeWarning: "Real Mode Risk Warning",
			realModeWarningContent:
				"You are about to enter real trading mode. All trades will be executed with real funds. Please make sure you understand the risks involved.",
			understand: "I Understand",

			// Other
			loginRequired: {
				title: "Please Login First",
				description:
					"You need to connect your wallet to use the Frontrunner Bot",
			},

			// IntegratedPositionsCard Related
			strategyTooStrict: "Strategy Too Strict",
			suggestTightenStrategy: "Suggest Tightening Strategy",
			hitRate: "Hit Rate",
			simulatedSell: "Simulated Sell",
			immediateSell: "Immediate Sell",
			positionCount: "Positions",
			completed: "Completed",
			profitShort: "Win",
			loss: "Loss",
			thisExecutionStats: "Current Execution Statistics",
			smartSuggestionsOptimization:
				"Smart Suggestions and Strategy Optimization",
			noDataYet: "No Data Yet",

			// MobilePositionsCard Related
			noActivePositions: "No Active Positions",
			noHistoryPositions: "No History Records",
		},
		pwa: {
			installTitle: "Install App",
			installDescription: "Install this application on your home screen for a better, faster, and offline-ready experience.",
			installButton: "Install Now",
			installGuideHint: "Install to your desktop for faster app-like access.",
			iosInstallTitle: "Install Application",
			iosInstallDescription: "Tap the share button and select 'Add to Home Screen' to install for the best experience.",
			pageLoadWaitingDescription: "Please wait for the page to fully load before installing the app.",
			androidCheckingDescription: "Checking install capability. Please wait and keep interacting with the page...",
			androidInstallPendingDescription: "The install request was accepted. Android may still need a few seconds to finish creating the app. Please keep this page open for a moment.",
			androidInstallDescription: "The native install prompt is not detected yet. Please install from the browser menu for now.",
			androidInstallReadyDescription: "Native install is now available. You can install to the home screen directly.",
			androidInstallInstruction: "Tap the top-right menu and choose 'Install app' or 'Add to Home screen'.",
			androidInstallFailedDescription: "The install request was accepted, but no installed app has been detected yet. Check the app drawer or system search for Odin, and retry if it is still missing.",
			androidInstallRetryInstruction: "Close the current tab completely, reopen the page, and try again. You can also use Chrome's menu entry 'Install app'.",
			genericInstallDescription: "Please add this app to your home screen from the browser menu for an app-like experience.",
			genericInstallInstruction: "Open the browser menu and choose 'Add to Home screen' or a similar option.",
			openInChrome: "Open in Chrome",
			copyLink: "Copy Link",
			linkCopied: "Link Copied",
			inAppBrowserWarning: "Unable to open directly due to app restrictions",
			openInBrowserInstruction: "Tap the top-right menu and select 'Open in Browser'",
		},
		settings: {
			title: "Settings",
			theme: "Theme",
			themeToggle: "Light / Dark",
			language: "Language",
			links: "Links",
			installApp: "Install App",
			vipBenefits: "VIP Benefits",
			buyToken: "Buy $BABYODIN",
			memeLibrary: "Meme Library",
			whitepaper: "Whitepaper",
		},
		view: {
			title: "View Mode",
			standard: "Community",
			standardDesc: "Plaza view, discover hot trends",
			pro: "Pro",
			proDesc: "Data view, master all market movements",
			focus: "Focus",
			focusDesc: "Project view, track specific tokens",
			setting: "Project Setting",
			searchPlaceholder: "Enter Token ID, name or ticker...",
			guideHint: "Switch between Plaza / Data / Focus views here.",
			guideAction: "Got it",
			switchSuccess: "Switched to {mode}",
		},
		event: {
			title: "OdinFun 0401 Incident Tracking",
			subtitle: "Tracking OdinFun abnormal fluctuations and fund flows",
			description: [
				"04-01 07:35 - Abnormal coordinated sell-offs detected across ~30 tokens (incl. BURRITO/CRYPTOBURG).",
				"04-01 08:24 - Potential exploit identified; platform withdrawal functions closed as a precaution.",
				"Latest - Attacker addresses identified and monitored; all funds are safe. Coordinating with law enforcement."
			],
			sections: {
				odin: "OdinFun Platform",
				icp: "ICP On-chain",
				btc: "BTC On-chain"
			},
			labels: {
				hackerId: "Suspected Hacker OdinFun Account",
				accountA: "Account A",
				accountB: "Account B",
				ckBtcAddress: "OdinFun Platform ckBTC Address",
				hackerBtcAddress: "Suspected Hacker BTC Address",
				transferHub: "Transfer Hub",
				eventExtractedBtcAddresses: "0401 Incident Extracted BTC Aggregation Addresses",
				internalTransfers: "Incoming Internal Transfers",
				withdrawals: "Withdrawal Records",
				withdrawerInfo: "Withdrawer Info",
				filterLabel: "Filter",
				hackerAddressFilter: "Suspected Hacker Address",
				otherAddressFilter: "Other Addresses",
				hackerAddressStats: "Suspected Hacker Address",
				otherAddressStats: "Other Addresses",
				accountCount: "Accounts",
				recordCount: "Records",
				totalBtc: "Total BTC",
				totalUsd: "USD Value",
				totalAmount: "Total Amount",
				balance: "Current Balance",
				historicalReceived: "Total Received",
				allTransferred: "Fully Transferred",
				transactions: "Transaction History",
				loading: "Loading...",
				noData: "No data available",
				stats: "Statistics",
				financialOverview: "Financial Overview",
				largeWithdrawalTracking: "Large Withdrawal Tracking",
				attackerIdentity: "Suspected Attacker Identity",
				securityProtocol: "Security Monitoring",
				time: "Time",
				index: "Index",
				timestamp: "Timestamp",
				amountCkBtc: "Amount (ckBTC)",
				recipient: "Recipient",
				action: "Action",
				usdValue: "USD Value",
				confirmedStatus: "Confirmed",
				pendingStatus: "Pending",
				blockstreamLive: "Blockstream Live",
				initializingTrackerData: "Initializing tracker data...",
				loadingWithdrawalData: "Loading withdrawal data...",
				senderInfo: "Sender Info",
				amountBtc: "Amount (BTC)",
				withdrawalAddress: "Withdrawal Address",
				btcMainnet: "BTC Mainnet",
				btcMainnetNode: "BTC Mainnet",
				hackerBtcNode: "Suspected Hacker BTC",
				transfer: "Transfer",
				withdrawToBtcMainnet: "Withdraw to BTC Mainnet",
				transferId: "Transfer ID",
				paginationSummary: "{start}-{end} of {total}",
				hackerAppeal: "URGENT: Attacker exchange account information and associated identities have been identified. Contact @BobBodily immediately for a White-hat solution to avoid further legal consequences.",
				viewAppealDetail: "View Official Statement",
				victimAppealTitle: "Odin Community Collective Action Initiative",
				victimAppealDesc: "Calling all Odin Community members to unite! Track assets, share clues, and assist OdinFun to recover funds.",
				groupName: "OdinFun0401 Incident Tracking",
				qqGroupLabel: "QQ Group ID: ",
				oneClickJoin: "One-click Join",
				copyGroupId: "Copy ID",
				groupId: "470786182"
			}
		},
	},
};
